/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_LeadInputs */

const en_mk_mx_lead = /** @type {(inputs: Mk_Mx_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every number in this table is a limit the system actually enforces, not a marketing promise. If you reach one, you are told before anything fails quietly.`)
};

const id_mk_mx_lead = /** @type {(inputs: Mk_Mx_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap angka di tabel ini adalah batas yang benar-benar ditegakkan sistem, bukan janji pemasaran. Kalau batas terlampaui, Anda diberi tahu sebelum ada yang gagal diam-diam.`)
};

/**
* | output |
* | --- |
* | "Every number in this table is a limit the system actually enforces, not a marketing promise. If you reach one, you are told before anything fails quietly." |
*
* @param {Mk_Mx_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_lead = /** @type {((inputs?: Mk_Mx_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_lead(inputs)
	return en_mk_mx_lead(inputs)
});